<template lang="html">
  <div :class="['Header', {home: currentPath == '/'}]" id="nav">
    <div class="logo" v-if="currentPath != '/'"><router-link to="/"><img src="@/assets/logo.svg" alt="CLIPLEAP" title="ClipLeap logo"></router-link><sup><i>(pre-Beta)</i></sup></div>
    <div class="logo" v-else><img src="@/assets/logo.svg" alt="CLIPLEAP" title="ClipLeap logo"><sup><i>(pre-Beta)</i></sup></div>
    <button v-on:click="$emit('openSignUp', {})" type="button" name="button" class="main">Add clip</button>
    <button v-on:click="$emit('openSignUp', {})" type="button" name="button">Sign-up</button>
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
  },
  computed: {
    currentPath() {
      return this.$route.path
    },
  },
}
</script>

<style lang="css" scoped>
.Header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3rem 0 2rem;
}
.Header.home {
  padding: 3rem 3rem 2rem;
}
.logo {
  flex-basis: 80%;
}
.home .logo {
  flex-basis: 70%;
}
p {
  flex-basis: 20%;
}
p {
  margin: 0;
}
img {
  vertical-align: middle;
}

/* inner pages */
img {
  height: 48px;
  margin-right: 8px;
}
sup {
  top: -11px;
}

/* home page  */
.home img {
  height: 60px;
  margin-right: 10px;
}
.home sup {
  top: -17px;
}



sup {
  font-weight: 200;
  font-size: 20px;
  display: inline-block;
  position: relative;
}
a {
  font-weight: bold;
  color: #2580da;
}
button {
  margin: 0 0 0 1rem;

  border: none;
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: 0.5rem;
  background: rgba(14, 85, 131, 0.0);
  color: #68828c;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  white-space: nowrap;
}
button.main {
  background: rgba(0, 90, 210, 0.6);
  /* background: rgba(14, 85, 131, 0.6); */
  /* background: rgb(0, 90, 210); */
}
button:hover {
  background: rgba(0, 90, 210, 0.86);;
  /* background-color: rgb(13, 71, 110); */
}
</style>
